import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=0352bf04&scoped=true&"
import script from "./loader.vue?vue&type=script&lang=js&"
export * from "./loader.vue?vue&type=script&lang=js&"
import style0 from "./loader.vue?vue&type=style&index=0&id=0352bf04&scoped=true&lang=css&"
import style1 from "./loader.vue?vue&type=style&index=1&id=0352bf04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0352bf04",
  null
  
)

export default component.exports